import React, { useState } from 'react'
import { MediaTitle, SortButtonsWrap, SortButton } from 'components/media/media.styled'
import { useDispatch, useSelector } from 'react-redux'
import { setSortAudio } from 'features/audio/audioSlice'
import { setSortVideo } from 'features/videos/videoSlice'
import SortIcon from '@mui/icons-material/Sort';
import { BsSortDown } from "react-icons/bs";
import { BsSortDownAlt } from "react-icons/bs";
import { useTranslation } from 'react-i18next'


export default function MediaSort({ section }) {
    const { t } = useTranslation('media')

    const dispatch = useDispatch()
    
    const { audioSort } = useSelector(state => state.audio)
    const { videoSort } = useSelector(state => state.video)
    const [sortState, setSortState] = useState("ascending");

    return (
        <MediaTitle>   
            <SortButtonsWrap> 
                {   
                    section === 'audio' ?
                    (
                        <SortButton
                            onClick={() => dispatch(setSortAudio(audioSort))}
                            >
                                <SortIcon />
                                {audioSort === 'ascending' ? t('newest') : t('oldest')}
                        </SortButton>
                    )
                    :
                    (
                        <SortButton
                            onClick={() => dispatch(setSortVideo(audioSort))}
                            >
                                <SortIcon />
                            {videoSort === 'ascending' ? t('newest') : t('oldest')}
                        </SortButton>
                    )
                }
            </SortButtonsWrap>
        </MediaTitle>
    )
}
